import { useEffect, useState } from 'react';

/** Ceasul aplicației. Un singur interval, partajat prin componenta care îl folosește. */
export function useNow(intervalMs = 1000): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);

  return now;
}
